import global from './styles/global';
import color from './styles/colors';
import font from './styles/font';
import breakpoints from './styles/breakpoints';
import icons from './styles/icons';

export default {
  ...global,
  color,
  font,
  breakpoints,
  icons,
};
